import { BASE_URL } from "../environment";
import makeRequest from "../makeRequest";

// ZEN service status enum (same values as serviceSearch.js)
const serviceStatuses = {
  0: 'Unknown',
  1: 'Active',
  2: 'Provisioning',
  3: 'CancelledInFlight',
  4: 'CeasedWithSupplier',
  5: 'ActiveCeasePending',
  6: 'Ceased',
  7: 'ActiveModifyPending',
  8: 'ActiveModifyInProgress'
};

const careLevels = { 0: 'None', 1: 'Standard', 2: 'Enhanced', 3: 'Critical' };
const networks   = { 0: 'Unknown', 1: 'NetworkOnNet', 2: 'NetworkOffNet' };

export async function searchVodafoneServices(searchTerm = "", pageIndex = 0, pageSize = 10, filterByPartner = "") {
  const params = new URLSearchParams({ searchTerm, page: pageIndex, pageSize });
  if (filterByPartner) params.append("filterByPartner", filterByPartner);

  const results = await makeRequest(`${BASE_URL}/vodafonesearchservices?${params.toString()}`);

  if (!results || !results.services?.length) {
    return { services: [], totalRecords: 0 };
  }

  return {
    services: results.services.map(mapVodafoneService),
    totalRecords: results.totalRecords ?? results.services.length
  };
}

export async function getVodafoneService(reference) {
  const result = await makeRequest(
    `${BASE_URL}/vodafonesearchservices?reference=${encodeURIComponent(reference)}`
  );

  if (!result?.services?.length) return null;
  return mapVodafoneService(result.services[0]);
}

// Maps the backend VodafoneService model to the same shape as mapZenService so the
// portal renders Vodafone and ZEN services identically.
function mapVodafoneService(service) {
  return {
    ...service,
    reference: service.zenReference,
    serviceStatus: serviceStatuses[service.serviceStatus] ?? 'Unknown',
    careLevel: careLevels[service.careLevel] ?? 'Standard',
    network: networks[service.network] ?? 'NetworkOnNet',
    cli: service.phoneNumber,
    product: service.productDescription,
    // Address fields flattened from installationAddress
    organisationName: service.installationAddress?.organisationName ?? '',
    subPremiseName:   service.installationAddress?.subPremiseName ?? '',
    premiseName:      service.installationAddress?.premiseName ?? '',
    thoroughfareNumber: service.installationAddress?.thoroughfareNumber ?? '',
    thoroughfare:     service.installationAddress?.thoroughfare ?? '',
    dependentThoroughfare: service.installationAddress?.dependentThoroughfare ?? '',
    postTown:         service.installationAddress?.postTown ?? '',
    postCode:         service.installationAddress?.postCode ?? '',
    startDate:        service.startDate ? new Date(service.startDate).toLocaleDateString() : '',
    supplier:         'Vodafone'
  };
}
